module.exports = __webpack_public_path__ + "static/media/menu-dots.c879777d.svg";